import { sendGTMEvent } from "@next/third-parties/google";

export const navigationClickTracking = (value: string) => sendGTMEvent({ event: "navigation_click", nav_item_name: value });
export const languageChangeTracking = (value: string) => sendGTMEvent({ event: "language_change", value: value });
export const contactChannelTracking = (method: string, project_name?: string) =>
  sendGTMEvent({ event: "contact_initiate", contact_method: method, ...(project_name && { project_name }) });
export const socialMediaTracking = (name: string) => sendGTMEvent({ event: "social_media_click", network: name });
export const newsletterTracking = (status: string) => sendGTMEvent({ event: "newsletter_subscription", subscription_status: status });
export const appDownloadTracking = (store: string) => sendGTMEvent({ event: "app_download_click", app_store: store });
export const policyTracking = (name: string) => sendGTMEvent({ event: "legal_policy_link_click", document_name: name });
export const footerLinkTracking = (category: string, name: string) =>
  sendGTMEvent({ event: "footer_link_click", link_category: category, link_name: name });
export const settingsChangeTracking = (currency: string, measurement: string) =>
  sendGTMEvent({ event: "settings_change", currency: currency, measurement_unit: measurement });

export const eventSectionTracking = (name: string, date: string) => {
  sendGTMEvent({ event: "event_section_interaction", event_name: name, event_date: date });
};
export const favoritesCartInteractionTracking = (type: string, count: string | number) => {
  sendGTMEvent({ event: "favorites_cart_interaction", interaction_type: type, item_count: count });
};

// TODO: FIXME: it looks like we're not using this funcion anymore. it could be deleted
// export const showAllUnitsClickTracking = (location: string, propertyType: string, bedrooms: string, priceRange: string, searchTerm: string) => {
//   sendGTMEvent({
//     event: "show_all_units_click",
//     location: location,
//     property_type: propertyType,
//     bedrooms: bedrooms,
//     price_range: priceRange,
//     // TODO: check what kind of field is searchTerm,
//     search_term: location,
//   });
// };

export const clearAllTracking = (searchTerm: string) => {
  sendGTMEvent({
    event: "clear_all_click",
    search_term: searchTerm,
  });
};
export const clearAllTrackingEvent = (location: string, propertyType: string, bedrooms: string, priceRange: any, searchTerm?: string | number) => {
  sendGTMEvent({
    event: "clear_all_click",
    location: location,
    property_type: propertyType,
    bedrooms: bedrooms,
    price_range: priceRange,
    search_term: location,
  });
};
export const projectPageViewEvent = (projectName?: string, propertyType?: string) => {
  sendGTMEvent({
    event: "project_page_view",
    project_name: projectName,
    project_type: propertyType,
  });
};
export const pushMetaversCtaClick = (
  cta_name?: string,
  project_name?: string,
  project_city?: string,
  project_type?: string,
  bedrooms_number?: string,
  title_text?: string,
) => {
  sendGTMEvent({
    event: "metaverse_entry_cta",
    cta_name: cta_name,
    project_name: project_name,
    project_city: project_city,
    project_type: project_type,
    bedrooms_number: bedrooms_number,
    title_text: title_text,
  });
};

// Event section CTA
export const ctaClickTracking = (cta_name: string, cta_location: string, event_name?: string, omitEventName?: boolean) => {
  omitEventName
    ? sendGTMEvent({
        event: "cta_click",
        cta_name: cta_name,
        cta_location: cta_location,
        event_date: new Date().toISOString(),
      })
    : sendGTMEvent({
        event: "cta_click",
        cta_name: cta_name,
        cta_location: cta_location,
        event_name: event_name,
        event_date: new Date().toISOString(),
      });
};

export const ctaClickTrackingWithProjectName = (
  cta_name: string,
  cta_location: string,
  event_name: string,
  project_name: string,
  isMetaverseCta?: boolean,
  ctaType?: string,
) =>
  ctaType == "3dVideo"
    ? sendGTMEvent({
        event: "metaverse_entry_cta",
        cta_name: cta_name,
        cta_location: cta_location,
        project_name: project_name,
        event_date: new Date().toISOString(),
      })
    : sendGTMEvent({
        event: "cta_click",
        cta_name: cta_name,
        cta_location: cta_location,
        // event_name: event_name,
        project_name: project_name,
        event_date: new Date().toISOString(),
      });

// "Learn more" button
export const buttonClickTracking = (name: string) => sendGTMEvent({ event: "button_click", button_name: name });

// "Learn more" button
export const pushButtonClick = (name: string, button_location: string, user_logged_in: boolean) =>
  sendGTMEvent({ event: "button_click", button_name: name, tile_text: name, button_location: button_location, user_logged_in: user_logged_in });

export const propertyCardClickTracking = (name: string) => sendGTMEvent({ event: "property_card_click", property_name: name });

// for all the forms submissions
export const leadFormSubmission = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "lead_form_submission", ...attributes };
  sendGTMEvent(body);
};
export const mortageleadFormSubmission = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "lead_form_submission", ...attributes };
  sendGTMEvent(body);
};

export const bookVisitTracking = (attributes: Record<string, any>) => {
  const body = { event: "unit_booking", ...attributes };
  sendGTMEvent(body);
};

export const entryPointCtaClick = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "entry_point_cta_click", ...attributes };
  // console.info("entryPointCtaClick", body);
  sendGTMEvent(body);
};

export const ecomViewWishlist = (items: any) => {
  const body = {
    event: "ecom_view_wishlist",
    ...items,
  };
  sendGTMEvent(body);
};

export const carouselClick = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "carousel_click", ...attributes };
  // console.info("carouselClick", body);
  sendGTMEvent(body);
};

export const brochureDowloadCtaClick = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "brochure_dowload_cta_click", ...attributes };
  // console.info("brochureDowloadCtaClick", body);
  sendGTMEvent(body);
};
export const propertyCardClick = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "property_card_click", ...attributes };
  // console.info("propertyCardClick", body);
  sendGTMEvent(body);
};

export const ecomProductCardClick = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "ecom_product_card_click", ...attributes };
  // console.info("ecomProductCardClick", body);
  sendGTMEvent(body);
};

export const searchInteractionTracking = () => sendGTMEvent({ event: "search_initiate", search_type: "property_search" });

let cumulativeFilters: Record<string, any> = {};

export const filterSelectionTracking = (location?: string, propertyType?: string, bedrooms?: string, priceRange?: any) => {
  if (location !== undefined) cumulativeFilters.location = location;
  if (propertyType !== undefined) cumulativeFilters.property_type = propertyType;
  if (bedrooms !== undefined) cumulativeFilters.bedrooms = bedrooms;
  if (priceRange !== undefined) cumulativeFilters.price_range = priceRange;

  const eventData: Record<string, any> = { event: "filter_selection" };
  Object.keys(cumulativeFilters).forEach((key) => {
    if (cumulativeFilters[key] && cumulativeFilters[key] !== "Any" && cumulativeFilters[key] !== "All location") {
      eventData[key] = cumulativeFilters[key];
    }
  });

  sendGTMEvent(eventData);
};

export const resetFilterTracking = () => {
  cumulativeFilters = {};
};

export const submitFilterTracking = () => {
  if (Object.keys(cumulativeFilters).length > 0) {
    const eventData: Record<string, any> = { event: "filter_selection" };
    Object.keys(cumulativeFilters).forEach((key) => {
      if (cumulativeFilters[key] && cumulativeFilters[key] !== "Any" && cumulativeFilters[key] !== "All location") {
        eventData[key] = cumulativeFilters[key];
      }
    });
    sendGTMEvent(eventData);
  }
};

export const showAllUnitsClick = (location: string, propertyType: string, bedrooms: string, priceRange: any, searchTerm?: string | number) => {
  sendGTMEvent({
    event: "show_all_units_click",
    location: location,
    property_type: propertyType,
    bedrooms: bedrooms,
    price_range: priceRange,
    search_term: location,
  });
};

export const lastSearchClick = (term: string) => {
  sendGTMEvent({
    event: "last_search_click",
    search_term: term,
  });
};

export const searchSuggestionClick = (term: string) => {
  sendGTMEvent({
    event: "search_suggestion_click",
    suggestion_term: term,
  });
};

// checkout events
export const ecomSelectReserve = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "ecom_select_reserve", ...attributes };
  console.info("ecomSelectReserve", body);
  sendGTMEvent(body);
};

export const ecomInitiateCheckout = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "ecom_initiate_checkout", ...attributes };
  console.info("ecomInitiateCheckout", body);
  sendGTMEvent(body);
};

export const signUpTracking = (attributes: Record<string, string | number | boolean>) => {
  sendGTMEvent({
    event: "sign-up",
    ...attributes,
  });
};
export const ecomCheckoutAddContactInformation = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "ecom_checkout_add_contact_information", ...attributes };
  //console.info("ecomCheckoutAddContactInformation", body);
  sendGTMEvent(body);
};
export const ecomSmsCodeSuccess = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "ecom_sms_code_success", ...attributes };
  //console.info("ecomSmsCodeSuccess", body);
  sendGTMEvent(body);
};
export const ecomCheckoutAddPaymentDetails = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "ecom_checkout_add_payment_details", ...attributes };
  //console.info("ecomCheckoutAddPaymentDetails", body);
  sendGTMEvent(body);
};
export const ecomPaymentSuccess = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "ecom_payment_success", ...attributes };
  //console.info("ecomPaymentSuccess", body);
  sendGTMEvent(body);
};
export const ecomSubmitPersonalDetails = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "ecom_submit_personal_details", ...attributes };
  //console.info("ecomSubmitPersonalDetails", body);
  sendGTMEvent(body);
};
export const ecomReservationComplete = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "ecom_reservation_complete", ...attributes };
  //console.info("ecomReservationComplete", body);
  sendGTMEvent(body);
};

export const mortgageCalculatorDataLayerEvent = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "mortgage_payment_enquire", ...attributes };
  sendGTMEvent(body);
};

export const ecomDownloadReceipt = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "ecom_download_receipt", ...attributes };
  //console.info("ecomDownloadReceipt", body);
  sendGTMEvent(body);
};

export const paymentPlanViewMoreDataLayerEvent = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "payment_plan_view_more", ...attributes };
  console.info("paymentPlanViewMoreDataLayerEvent", body);
  sendGTMEvent(body);
};
export const contactUs = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "contact_us", ...attributes };
  //console.info("contactUs", body);
  sendGTMEvent(body);
};

export const ecomAddToWishlist = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "ecom_add_to_wishlist", ...attributes };
  //console.info("ecomAddToWishlist", body);
  sendGTMEvent(body);
};
// TODO implement once the page/component is defined
export const emailSubscriptionSuccess = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "email_subscription_success", ...attributes };
  //console.info("emailSubscriptionSuccess", body);
  sendGTMEvent(body);
};
export const browsePropertiesHeaderLinkClick = (attributes: Record<string, string | number | boolean>, headerLink: string) => {
  const body = { event: `${headerLink.toLowerCase().replace(/\s+/g, "_")}_header_link_click`, ...attributes };
  //console.info("browsePropertiesHeaderLinkClick", body);
  sendGTMEvent(body);
};

export const pushCarouselClick = (
  eventName: string,
  carouselName?: string,
  carouselPage?: string,
  titleText?: string,
  user_logged_in?: boolean,
  userId?: number,
) => {
  sendGTMEvent({
    event: eventName,
    carousel_name: carouselName,
    carousel_page: carouselPage,
    titleText: titleText,
    user_logged_in: user_logged_in,
    user_id: userId,
  });
};

export const blogLinkClick = (blog_name: string) => sendGTMEvent({ event: "blogs_link_click", link_category: "Blog Click", link_name: blog_name });

export const matterPortPlayButtonClicked = (cta_name: string, cta_location: string, event: string) =>
  sendGTMEvent({ cta_name: cta_name, cta_location: cta_location, event: event, event_date: new Date().toISOString() });

export const testimonialsCardClick = (attributes: Record<string, string | number | boolean>) => {
  // debugger;
  const body = { event: "tileCarousel_card_click", event_date: new Date().toISOString(), ...attributes };
  // console.info("testimonialsCardClick", body);
  sendGTMEvent(body);
};
export const testimonialsCardEntryPage = (attributes: Record<string, string | number | boolean>) => {
  // debugger;
  const body = { event: "tileCarousel_card_entry_page", event_date: new Date().toISOString(), ...attributes };
  // console.info("testimonialsCardClick", body);
  sendGTMEvent(body);
};

// TODO implement once the page/component is defined
export const metaversePayEoiClick = (attributes: Record<string, string | number | boolean>) => {
  const body = { event: "metaverse_pay_eoi", ...attributes };
  //console.info("metaversePayEoiClick", body);
  sendGTMEvent(body);
};

export const pushImmersiveExperience = (location: string, ctaName: string, ctaLocation: string, pageUrl: any) => {
  sendGTMEvent({
    event: "immersive_experience",
    cta_name: ctaName,
    cta_location: ctaLocation,
    page_url: pageUrl,
  });
};
